import $ from 'jquery'
import 'lazyloadxt/src/jquery.lazyloadxt'
import 'lazyloadxt/src/jquery.lazyloadxt.srcset'
import 'lazyloadxt/src/jquery.lazyloadxt.bg'

$.extend($.lazyLoadXT, {
  edgeY: 900,
  blankImage: 'data:image/gif;base64,R0lGODdhAQABAIABABcXF////ywAAAAAAQABAAACAkQBADs='
})

export default {
  $: $,
  lazyLoadXT: $.lazyLoadXT
}



// WEBPACK FOOTER //
// ./src/common/js/lazyload/lazyload.js